import Loading from '@/components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initializeCsrfToken } from '../utils/auth';
import { getAndClearLoginInfoFromStorage } from '../utils/loginInfo';
import { apiPostRequest, apiGetRequest } from '../utils/apiClient';
import { runMigrations } from '../utils/migrations';

const AuthCallback = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const initializeSession = async () => {
            try {
                // CSRFトークンを初期化（明示的に取得）
                await initializeCsrfToken();

                // ログイン情報を取得してバックエンドに送信
                const loginInfo = getAndClearLoginInfoFromStorage();
                if (loginInfo) {
                    try {
                        await apiPostRequest('/api/auth/record-login-history', loginInfo);
                    } catch (error) {}
                }

                // ユーザー情報を取得してuserIdを取得
                const userInfoRes = await apiGetRequest('/api/user/info');
                if (userInfoRes?.ok) {
                    const userInfo = await userInfoRes.json();
                    if (userInfo.userId) {
                        // マイグレーションを実行
                        await runMigrations(userInfo.userId);
                    }
                }

                // トークン取得 or バックエンド確認済みならログイン成功とみなして遷移
                navigate('/desk');
            } catch (error) {
                // エラーが発生しても遷移を実行
                navigate('/desk');
            }
        };

        initializeSession();
    }, [navigate]);

    return <Loading />;
};

export default AuthCallback;
